export default {
  dashboard: {
    global: {
      background: 'rgba(151,157,173,0.12)',
      card: '#ffffff',
      textColor: '#424256'
    },
    kindsOverview: {
      background: '#f5f6fa',
      projectIconBackground: '#ffffff',
      card: '#ffffff',
      textColor: '#424256',
      detailButtonBackground: 'rgba(151,157,173,0.6)',
      chartLineColor: '#d6d8df'
    }
  }
}
